export default{
  "Mute Video": "Stummes Video",
  "HitPaw Online Mute Video": "HitPaw Online Video stummschalten",
  "Fast and easy to remove sound from your video online": "Schnell und einfach den Ton aus Ihrem Video online entfernen",
  "Muting": "Mute…",
  "Mute Failed": "Mute fehlgeschlagen",
  "Mute New": "Mute mehr"
};